angular.module('TetherApp').factory('conversationService', [
    '$http',
    function ($http) {
        let randomString = function (length, chars) {
            let result = '';
            for (let i = length; i > 0; --i) result += chars[Math.round(Math.random() * (chars.length - 1))];
            return result;
        };

        let getInbox = function (shortcodeId, page, search, read_at, field, direction, marked_at) {
            let uri = '/api/v1/conversations/inbox/' + shortcodeId + '/' +
                randomString(
                    16,
                    '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
                );
            let getParams = '?';
            let divider = '&';
            if (page != undefined) {
                if (getParams.length > 1) {
                    getParams += divider;
                }
                getParams += 'page=' + page;
            }
            if (search != undefined) {
                if (getParams.length > 1) {
                    getParams += divider;
                }
                getParams += 'search=' + search;
            }
            if (read_at != undefined) {
                if (getParams.length > 1) {
                    getParams += divider;
                }
                getParams += 'read_at=' + read_at;
            }
            if (field != undefined) {
                if (getParams.length > 1) {
                    getParams += divider;
                }
                getParams += 'field=' + field;
            }
            if (direction != undefined) {
                if (getParams.length > 1) {
                    getParams += divider;
                }
                getParams += 'direction=' + direction;
            }
            if (marked_at != undefined) {
                if (getParams.length > 1) {
                    getParams += divider;
                }
                getParams += 'marked_at=' + marked_at;
            }
            if (getParams.length > 1) {
                uri += getParams;
            }
            return $http.get(
                uri,
                {
                    cache: false,
                    headers: { 'Cache-Control' : 'no-cache' }
                }
            )
                .then(
                    function (response) {
                        return response.data;
                    }
                );
        };

        let getUnreadCount = function (data) {
            return $http.get('/api/notification-stats', {
                cache: false,
                headers: { 'Cache-Control' : 'no-cache' },
                params: data
            }).then(function (response) {
                return response.data;
            });
        };

        let searchMessagesForParticipant = function (shortcodeId, query, page) {
            let uri = '/api/v1/conversations/search/' + shortcodeId + '/participants/' + query + '/' +
                randomString(
                    16,
                    '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
                );
            if (page != undefined) {
                uri += '/?page=' + page;
            }
            return $http.get(
                uri,
                {
                    cache: false,
                    headers: { 'Cache-Control' : 'no-cache' }
                }
            )
                .then(
                    function (response) {
                        return response.data;
                    }
                );
        };

        let updateReadStatus = function (conversationId, isForced) {
            let url = '/api/v1/conversations/read-status/' + conversationId;
            if (isForced != undefined && isForced == 1) {
                url += '/1';
            } else {
                url += '/0';
            }
            return $http.put(
                url,
                {},
                {
                    cache: false,
                    headers: { 'Cache-Control' : 'no-cache' }
                }
            )
                .then(
                    function (response) {
                        return response.data;
                    }
                );
        };

        let getExperiences = function () {
            let uri = '/api/v1/experiences/conversation/' +
                randomString(
                    16,
                    '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
                );
            return $http.get(
                uri,
                {
                    cache: false,
                    headers: { 'Cache-Control' : 'no-cache' }
                }
            )
                .then(
                    function (response) {
                        return response.data;
                    }
                );
        };

        let updateMarkedStatus = function (conversationId, isForced) {
            let url = '/api/v1/conversations/marked-status/' + conversationId;
            if (isForced != undefined && isForced == 1) {
                url += '/1';
            } else {
                url += '/0';
            }
            return $http.put(
                url,
                {},
                {
                    cache: false,
                    headers: { 'Cache-Control' : 'no-cache' }
                }
            )
                .then(
                    function (response) {
                        return response.data;
                    }
                );
        };

        return {
            getInbox: getInbox,
            getUnreadCount: getUnreadCount,
            searchMessagesForParticipant: searchMessagesForParticipant,
            updateReadStatus: updateReadStatus,
            getExperiences: getExperiences,
            updateMarkedStatus: updateMarkedStatus
        }

    }
]);
